import { useMemo } from "react";

import {
  branchToLocationDetail,
  branchesToBookingLocations,
  findBranchByValue,
  getBranchLocationDetail,
  getBranchLocationLabel,
} from "@/lib/booking/locations";
import { useAppSelector } from "@/lib/redux/hooks";
import {
  selectBranches,
  selectMasterDataError,
  selectMasterDataStatus,
} from "@/lib/redux/features/master-data/masterDataSlice";

export function useBookingLocations() {
  const branches = useAppSelector(selectBranches);
  const status = useAppSelector(selectMasterDataStatus);
  const error = useAppSelector(selectMasterDataError);

  const locations = useMemo(
    () => branchesToBookingLocations(branches),
    [branches],
  );

  return {
    branches,
    locations,
    status,
    error,
    isLoading: status === "idle" || status === "loading",
    isReady: status === "succeeded" && branches.length > 0,
    getLocationLabel: (value: string) =>
      getBranchLocationLabel(branches, value),
    getLocationDetail: (value: string) =>
      getBranchLocationDetail(branches, value),
    getBranch: (value: string) => findBranchByValue(branches, value),
    getBranchDetail: branchToLocationDetail,
  };
}
